import React, { Fragment,useEffect } from "react";
import "../../styles/adminlte.css";
import { Outlet } from "react-router-dom";


const Layout = () => {

  useEffect(() => {
    document.title = "Blessed Builders Sober Living Homes : Admin Authentication"
 }, []);
  return (
    <Fragment>
      <div className="auth ">
        <section className=""  >
         
                <Outlet/>
              
        </section>
      </div>
    </Fragment>
  );
};

export default Layout;
